/**
 * Select - re-exported from @elsapiens/ui
 *
 * Uses the elSDK design system Select with proper CSS classes (el-select),
 * CSS variables for theming, and built-in dark mode support.
 *
 * The elSDK Select's onChange passes the selected value as a string directly,
 * but the compiled .d.ts inherits ChangeEventHandler from SelectHTMLAttributes.
 * This wrapper fixes the type to match the runtime behavior.
 */
import { type ForwardRefExoticComponent, type RefAttributes } from 'react'

import { Select as ElSelect, type SelectProps as ElSelectProps, type SelectOption } from '@elsapiens/ui'

export type { SelectOption }

export interface SelectProps extends Omit<ElSelectProps, 'onChange'> {
  onChange?: (value: string) => void
}

export const Select = ElSelect as unknown as ForwardRefExoticComponent<SelectProps & RefAttributes<HTMLSelectElement>>

/** @deprecated Use inline union type instead */
export type SelectValidationState = 'default' | 'valid' | 'invalid'
